var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCsvFile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2167ae",
    d: "M17 10h-1V5a1 1 0 0 0-1-1H9v3.5C9 8.33 8.33 9 7.5 9H4v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-1h1v1a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V9.04c0-.52.2-1.01.55-1.38l3.86-4.04A2 2 0 0 1 8.86 3H15a2 2 0 0 1 2 2zM8 4.45 4.6 8h2.9a.5.5 0 0 0 .5-.5zm-.02 12.68q-.87 0-1.5-.38-.63-.37-.97-1.05a3.4 3.4 0 0 1-.33-1.52q0-.85.32-1.5.34-.68.96-1.06.64-.38 1.5-.38.98 0 1.64.55t.8 1.51H9.37q-.15-.54-.5-.83t-.9-.29a1.6 1.6 0 0 0-1.52 1q-.2.45-.2 1 0 .92.45 1.46t1.26.54q.57 0 .92-.3t.5-.84h1q-.07.62-.4 1.1-.3.47-.82.73a3 3 0 0 1-1.17.26m5.63 0q-1.09 0-1.74-.53a2 2 0 0 1-.7-1.43h1.14q.06.5.38.77.33.25.9.25.53 0 .84-.2a.7.7 0 0 0 .33-.59.5.5 0 0 0-.15-.37 1 1 0 0 0-.42-.23 7 7 0 0 0-.82-.2q-.66-.14-1.1-.33a1.6 1.6 0 0 1-.66-.5q-.24-.33-.24-.83 0-.53.28-.92.27-.38.77-.58t1.14-.2 1.12.22A1.8 1.8 0 0 1 15.74 13h-1.11a1 1 0 0 0-.34-.62q-.3-.23-.76-.23t-.76.2q-.28.18-.28.5 0 .2.12.33.15.12.4.21.27.09.77.2.72.13 1.15.33.45.19.7.54.26.34.26.88 0 .55-.3.96t-.8.61a3 3 0 0 1-1.18.22M18.5 17h1.28l2.06-5.63H20.7l-1.56 4.31-1.56-4.31h-1.13z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsvFile);
export default __webpack_public_path__ + "static/media/CSVFile.e9ae9213220157c43a233724667b6b0f.svg";
export { ForwardRef as ReactComponent };